/**
 * Live DP location — Socket.IO event contract (works with $0 extra vendors if you self-host).
 *
 * Self-host options (no Pusher/Ably subscription required):
 * - Laravel 11+: Reverb (built-in WebSocket server on your VPS).
 * - Soketi: open-source Pusher protocol server (Docker).
 * - Small Node process: socket.io + Redis adapter, same machine as API.
 *
 * Flow:
 * 1) DP emits CLIENT_EMIT: { userId, latitude, longitude, current_*, delivery_assigned_order_id?, ... }
 * 2) Your server validates, may call the same logic as set-dp-current-location, then
 *    emits ADMIN_EVENT to room "admin" or per-order room so only relevant admins receive it.
 * 3) Admin UI listens for ADMIN_EVENT (below) for real-time marker moves.
 *
 * Laravel can listen for dp_location_update via a Node bridge, or DP POSTs to Laravel and
 * Laravel broadcasts with Reverb — same outcome.
 */
export const SOCKET_DP_LOCATION_CLIENT_EMIT = "dp_location_update";
export const SOCKET_DP_LOCATION_ADMIN_EVENT = "dp_live_location";

/** DP saves position (POST). */
export const DP_LIVE_LOCATION_REST_PATH = "delivery-partner/set-dp-current-location";

/** Admin reads last saved position (GET). Query: delivery_assigned_order_id= or rfq_product_id= */
export const ADMIN_GET_DP_CURRENT_LOCATION_PATH = "admin/get-dp-current-location";

export function parseLocationPayloadLatLng(raw) {
  if (!raw || typeof raw !== "object") return { lat: null, lng: null };
  const inner =
    raw.data != null && typeof raw.data === "object" && !Array.isArray(raw.data)
      ? raw.data
      : raw;
  const lat = Number(
    inner.latitude ??
      inner.lat ??
      inner.current_latitude ??
      inner.delivery_latitude
  );
  const lng = Number(
    inner.longitude ??
      inner.lng ??
      inner.current_longitude ??
      inner.delivery_longitude
  );
  return {
    lat: Number.isFinite(lat) ? lat : null,
    lng: Number.isFinite(lng) ? lng : null,
  };
}

export function getDeliveryPartnerTrackingUserId(dp) {
  if (!dp || typeof dp !== "object") return null;
  const raw =
    dp.user_id ??
    dp.delivery_user_id ??
    dp.dp_user_id ??
    dp.value ??
    null;
  return raw != null ? String(raw) : null;
}

export function deliveryPartnerMatchesLocationPayload(dp, data) {
  if (!dp || !data || typeof data !== "object") return false;
  const dpUser = getDeliveryPartnerTrackingUserId(dp);
  const pUser = data.userId ?? data.user_id;
  if (dpUser != null && pUser != null && String(dpUser) === String(pUser)) {
    return true;
  }
  const assignmentId =
    data.delivery_assigned_order_id ?? data.delivery_partner_id ?? data.dp_assignment_id;
  if (assignmentId != null && dp.id != null && String(dp.id) === String(assignmentId)) {
    return true;
  }
  const rfqPid = data.rfq_product_id;
  if (rfqPid != null && dp.rfq_product_id != null && String(dp.rfq_product_id) === String(rfqPid)) {
    return true;
  }
  return false;
}
